"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _selectInput = _interopRequireDefault(require("../selectInput/selectInput"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formInlineModule = _interopRequireDefault(require("./formInline.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FormInline = function FormInline(props) {
  var id = props.id,
      inputProps = props.inputProps,
      label = props.label,
      _props$viewControlTes = props.viewControlTestId,
      viewControlTestId = _props$viewControlTes === void 0 ? 'view-control' : _props$viewControlTes; // Add dataTestId to props

  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _formInlineModule.default["form-group"], _formInlineModule.default["form-inline"]),
    "data-testid": viewControlTestId // Apply the data-testid here

  }, _react.default.createElement("label", {
    id: id ? "".concat(id, "_label") : null,
    className: _formInlineModule.default["control-label"]
  }, label), _react.default.createElement("div", {
    id: id ? "".concat(id, "_input_wrapper") : null,
    className: _formInlineModule.default.selectWrapper
  }, _react.default.createElement(_selectInput.default, _extends({}, inputProps, {
    id: id ? "".concat(id, "_form_line_input") : null
  }))));
};

FormInline.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case */
  id: _propTypes.default.string,

  /** Object that must contain the required input props of the SelectInput component */
  inputProps: _propTypes.default.object.isRequired,

  /** String text that will be displayed next to the input */
  label: _propTypes.default.string,

  /** data-testid prop for testing purposes */
  viewControlTestId: _propTypes.default.string // formInlineTestId prop type

};
var _default = FormInline;
exports.default = _default;